import { useEffect, useRef } from 'react';
import { TUIChatEngine, TUIStore, StoreName, TUIConversationService, IConversationModel } from '@tencentcloud/chat-uikit-engine';
import Chatbox from '@/components/Chatbox';
import { useOutlet } from '@/context/OutletContext';

import '@/styles/index.scss';
import './ChatboxPage.scss';

export default function ChatboxPage() {
  const { env } = useOutlet();
  const isFirstRender = useRef<boolean>(false);

  useEffect(() => {
    TUIStore.watch(StoreName.CONV, {
      conversationList: onConversationListUpdated,
    });
    return () => {
      TUIStore.unwatch(StoreName.CONV, {
        conversationList: onConversationListUpdated,
      });
    };
  }, []);

  function onConversationListUpdated(conversationList: IConversationModel[]) {
    if (isFirstRender.current) {
      return;
    }
    // default open first group chat
    const firstGroupChat = conversationList.find((item: IConversationModel) => item.type === TUIChatEngine.TYPES.CONV_GROUP);
    if (firstGroupChat && firstGroupChat.conversationID) {
      TUIConversationService.switchConversation(firstGroupChat.conversationID);
      isFirstRender.current = true;
    }
  }

  return (
    <div className={`chatbox-container chatbox-container-${env} ${env === 'mobile' ? 'mobile-container' : 'web-container'}`}>
      <Chatbox />
    </div>
  );
}
